import { connect } from "react-redux"
import React, { Component } from 'react'
import trans from "trans"

import { Project, ShapeSet } from "app/types/model-types"

import {
    css,
    Grid,
    GridCell,
    Button,
} from "@bdfx/mergado-ui-kit"

import ShapeType, {
    AllowedShapeTypes, BRUSH_TYPE, BADGE_TYPE, BEZIER_TYPE, CIRCLE_TEXT_TYPE, CIRCLE_TYPE, CURVED_TEXT_TYPE, CUSTOM_SET_TYPE, DASHED_FRAME_TYPE, DYNAMIC_TEXT_TYPE,
    IMAGE_FROM_ELEMENTS_TYPE, LINE_TYPE, POLYGON_TYPE, RECTANGLE_TYPE, TEXT_INSIDE_SHAPE_TYPE, TEXT_TYPE, TEXT_WITH_ELEMENTS_TYPE, TRIANGLE1_TYPE,
    EXTERNAL_IMAGE_SOURCE_TYPE, RATING_TYPE
} from "shape-entities/types/shape"

import getShape from "shape-entities/defaults";

import {
    updateInputValue as change,
} from "app/reducers/form";

import { setActiveShapeId, setActiveView } from "../reducers";

import { getIconByType } from "shape-list/components/shape-list-item";
import { getFormName, getTemplateSize, reorderShapes } from "../forms/helpers";
import { selectFormValue} from "app/reducers/form"
import { ACTIVE_VIEW_EDIT_SHAPE } from "template-edit/containers/Editor"
import { testUsers } from "template-edit/components/helper"
import { ReduxList } from "app/types/app-types"

interface Props {
    isAlt: boolean
    shapes: ShapeType[]
    project: ReduxList<Project>
    setActiveShapeId: typeof setActiveShapeId
    setActiveView: typeof setActiveView
    change: typeof change
}

type ItemType = {
    shapeType: AllowedShapeTypes
    transKey: string
    isHidden: boolean
}
/**
 * New shape selection. Select a new shape from available shapes.
 */
class ShapeSelection extends Component<Props> {
    constructor(props) {
        super(props)
    }

    selectShape = (type: string, shapeSet: ShapeSet = null) => {
        const { shapes } = this.props

        const templateSize = getTemplateSize()

        let newShape: ShapeType = getShape(type, {
            width: templateSize.width,
            height: templateSize.height,
        }, 0)


        if (shapeSet) {
            newShape.set_id = parseInt(shapeSet.id.toString())
            if (shapeSet) { //cannot be null?
                newShape.set = shapeSet
            }
        }

        //reorder shapes and set priority here:
        let newShapes = [];
        newShapes[newShape.index] = newShape
        reorderShapes({ ...newShapes, ...shapes }, [newShape.index, ...Object.keys(shapes)])
        this.props.setActiveView(ACTIVE_VIEW_EDIT_SHAPE)
        this.props.setActiveShapeId(newShape.index)
    }

    render() {
        const iconSize = 40

        const renderList: readonly ItemType[] = [
            { shapeType: TEXT_TYPE, transKey: TEXT_TYPE, isHidden: false },
            { shapeType: DYNAMIC_TEXT_TYPE, transKey: DYNAMIC_TEXT_TYPE, isHidden: false },
            { shapeType: TEXT_WITH_ELEMENTS_TYPE, transKey: TEXT_WITH_ELEMENTS_TYPE, isHidden: false },
            { shapeType: RATING_TYPE, transKey: 'rating_from_element', isHidden: false },
            { shapeType: IMAGE_FROM_ELEMENTS_TYPE, transKey: IMAGE_FROM_ELEMENTS_TYPE, isHidden: false },
            { shapeType: CUSTOM_SET_TYPE, transKey: 'uploaded_images', isHidden: false },
            { shapeType: RECTANGLE_TYPE, transKey: RECTANGLE_TYPE, isHidden: false },
            { shapeType: CIRCLE_TYPE, transKey: CIRCLE_TYPE, isHidden: false },
            { shapeType: EXTERNAL_IMAGE_SOURCE_TYPE, transKey: 'external_image', isHidden: false },
            { shapeType: DASHED_FRAME_TYPE, transKey: DASHED_FRAME_TYPE, isHidden: false },
            { shapeType: LINE_TYPE, transKey: LINE_TYPE, isHidden: false },
            { shapeType: BRUSH_TYPE, transKey: BRUSH_TYPE, isHidden: false },

            //hidden:
            { shapeType: TRIANGLE1_TYPE, transKey: 'triangle', isHidden: true },
            { shapeType: TEXT_INSIDE_SHAPE_TYPE, transKey: TEXT_INSIDE_SHAPE_TYPE, isHidden: true },
            { shapeType: CURVED_TEXT_TYPE, transKey: CURVED_TEXT_TYPE, isHidden: true },
            { shapeType: POLYGON_TYPE, transKey: POLYGON_TYPE, isHidden: true },
            { shapeType: BEZIER_TYPE, transKey: BEZIER_TYPE, isHidden: true },
            { shapeType: CIRCLE_TEXT_TYPE, transKey: CIRCLE_TEXT_TYPE, isHidden: true },
        ]

        const userId = this.props.project.data?.user?.id ?? null
        const isTestUser = testUsers.includes(userId)
        return (
            <ShapeGrid cols="repeat(auto-fit, minmax(100px, 1fr))" gap={"10px"}>
                {renderList.filter(item => !item.isHidden).map(item =>
                    <Button secondary={true} onClick={() => this.selectShape(item.shapeType)} key={item.shapeType}>
                        <div className={'thumb-wrapper'}>{getIconByType(item.shapeType, iconSize, '#009ca8')}</div>
                        <div className={'muk-icon__text'}>{trans(item.transKey)}</div>
                    </Button>
                )}

                {isTestUser &&
                    renderList.filter(item => item.isHidden).map(item =>
                    <Button secondary={true} onClick={() => this.selectShape(item.shapeType)} key={item.shapeType}>
                        <div className={'thumb-wrapper some-users-only'}>{getIconByType(item.shapeType, iconSize, '#009ca8')}</div>
                        <div className={'muk-icon__text some-users-only'}>{trans(item.transKey)}</div>
                    </Button>
                )}
            </ShapeGrid>
        )
    }
}

export const ShapeGrid = css(Grid)({
    background: '#fff',
    padding: '10px',
    textAlign: 'center',
    alignSelf: 'center',

    ".muk-button": {
        padding: '10px',
        border: "1px solid #ddd",
        ".muk-icon__text": {
            fontWeight: "normal",
            color: "#333",
            fontSize: "14px",
            paddingTop: '10px',
        },
    },

    " .set-chooser": {
        cursor: "pointer",
        overflow: "hidden",
        position: "relative",
        borderRadius: "5px",
        border: "1px solid #ccc",
        textAlign: "center",
        padding: 0,
        " img": {
            transition: "transform 0.2s",
            transform: "scale3d(1,1,1)",
            opacity: 0.07,
            width: "100%",
            height: 'auto',
            overflow: 'hidden',
            ":hover": {
                transition: "transform 0.8s",
                transform: "scale3d(1.5,1.5,1)"
            },
        },
        " span": {
            fontSize: "12px",
            display: "block",
            textTransform: "uppercase",
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            lineHeight: "1.2em",
            textAlign: "center",
            width: "100%",
        },
    },
})

export const ShapeGridItem = css(GridCell)({
    borderRadius: "5px",
    textAlign: "center",
    cursor: "pointer",
    fontSize: "14px",
    color: "#333",
    border: '1px solid #ddd',
    transition: "background-color 0.2s",
    minHeight: '100px',
    height: '100%',
    ' .thumb-wrapper': {
        height: 'auto',
        padding: '2em 10px',
        lineHeight: '1.5em',
    },
    ":hover": {
        backgroundColor: "#ddd",
    },
    " path": {
        // fill: "#333"
    },
})


function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        shapes: selectFormValue(state, getFormName(state.isAlt), 'shapes'),
        project: state.project,
    }
}

export default connect(mapStateToProps, {
    setActiveView,
    setActiveShapeId,
    change,
})(ShapeSelection)